/*

FILE: links.js
DESCRIPTION: Custom functionality for links
AUTHOR(S): R.J. LaCount

*/

import animateScrollTo from 'animated-scroll-to';

/**
 * @function
 * @description For smooth scrolling
 * @param {object} e - click event
 * @param {object} e - includes if you'd like to update history
 */
const scrollToDest = (e, options) => {
    const el = e.target.hash ? document.querySelector(e.target.hash) : 0;
    const updateUrl = e.target.hash ? (window.location + e.target.hash) : window.location.href.split('#')[0];
    animateScrollTo(el, {
        maxDuration: 2000,
        minDuration: 300,
        speed: 500,
        verticalOffset: e.target.hash ? -80 : 0,
    });
    if (options !== undefined && !options.disableNavUpdate) window.history.replaceState(null, null, updateUrl);
};

/**
 * @function
 * @description returns if the link clicked is on the same page or not
 * @param {object} link - link element
 */
const isSamePage = (link) => (link.origin === window.location.origin) && (link.pathname === window.location.pathname);

/**
 * @function
 * @description Checks clicked link to see if it should be a jump link
 * @param {object} e - click event
 * @param {object} e - includes if you'd like to update history
 */
const linkClicked = (e, options) => {
    if (
        !e.target.classList.contains('app-preview__link')
        && (e.target.classList.contains('jump-to-top') || (isSamePage(e.target) && e.target.hash))
    ) {
        e.preventDefault();
        e.stopPropagation();
        scrollToDest(e, options);
    }
};

export { linkClicked as default };
